// extracted by mini-css-extract-plugin
export default {"noData":"tablePlaceholder_noData__S23MR"};